import React, { lazy, Suspense } from 'react';
import ProtectedRoute from '../../shared/components/ProtectedRoute';
import LoadingSpinner from '../../shared/components/LoadingSpinner';

// Lazy load certification components
const CertifyLivestockList = lazy(() => import('../../routes/certification/CertifyLivestock'));

/**
 * Certification feature routes with lazy loading
 */
export const certificationRoutes = [
  {
    path: '/certify-livestock/:poolCode',
    element: (
      <ProtectedRoute requiredRoles={['LMS.CertVerification']}>
        <Suspense fallback={<LoadingSpinner message="Loading certification..." />}>
          <CertifyLivestockList />
        </Suspense>
      </ProtectedRoute>
    ),
  },
];

export default certificationRoutes;

